import React, { useEffect, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import Accept_Privacy from "../Delegations/ComponentsDelegation/Accept_Privacy";
import ModalInfo from "../Generics/ModalInfo";

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

const PdfViewer = ({
  fileUrl,
  privacyAccepted,
  setPrivacyAccepted,
  hideCheckbox = false,
  fullSize = false,
}) => {
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfPages, setPdfPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const [openPrivacyWarning, setOpenPrivacyWarning] = useState(false);

  useEffect(() => {
    if (!fileUrl) return;
    const fetchPdf = async () => {
      setLoading(true);
      try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        setPdfBlob(blob);
      } catch (err) {
        console.error("Errore", err);
        setLoading(false);
      }
    };
    fetchPdf();
  }, [fileUrl]);

  useEffect(() => {
    if (!pdfBlob) return;
    const renderPdf = async () => {
      try {
        const arrayBuffer = await pdfBlob.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        const pages = [];
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.8 });
          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          const context = canvas.getContext("2d");
          await page.render({ canvasContext: context, viewport }).promise;
          pages.push(canvas.toDataURL());
          if (i === 1) setPdfPages([...pages]);
        }
        setPdfPages(pages);
      } catch (err) {
        console.error("Errore", err);
      } finally {
        setLoading(false);
      }
    };
    renderPdf();
  }, [pdfBlob]);

  return (
    <>
      <Grid
        item
        xs={12}
        md={fullSize ? 12 : 8}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          marginBottom: fullSize ? 0 : { xs: "0px", md: "100px" },
        }}
      >
        <div
          style={{
            width: "100%",
            height: fullSize ? "100%" : "600px",
            minHeight: fullSize ? "100%" : undefined,
            boxSizing: "border-box",
            overflowY: loading ? "hidden" : "auto",
            border: fullSize ? "none" : "1px solid #ccc",
            marginBottom: fullSize ? 0 : "12px",
            position: "relative",
          }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(0, 0, 0, 0.33)",
                zIndex: 10,
              }}
            >
              <CircularProgress style={{ color: "#fff" }} />
            </div>
          )}
          {pdfPages.map((pageSrc, index) => (
            <img
              key={index}
              src={pageSrc}
              alt={`Pagina ${index + 1}`}
              style={{ display: "block", marginBottom: "10px", width: "100%" }}
            />
          ))}
        </div>

        {!hideCheckbox && (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              mt: "5px",
            }}
          >
            <Checkbox
              checked={privacyAccepted}
              onChange={(e) => setPrivacyAccepted(e.target.checked)}
              disableRipple
              sx={{
                pt: "2px",
                color: "#1b2838",
                ml: "-12px",
                "&.Mui-checked": {
                  color: "#1b2838",
                },

                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            />

            <Typography sx={{ lineHeight: 1.5 }}>
              Ho preso visione del{" "}
              <Typography
                component="span"
                onClick={() => setOpenPrivacyModal(true)}
                className="link"
                sx={{
                  color: "primary.main",
                  textDecoration: "underline",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "none",
                  },
                }}
              >
                disclaimer sulla firma e dell'informativa privacy
              </Typography>
            </Typography>
          </Box>
        )}
      </Grid>

      <Modal
        open={openPrivacyModal}
        onClose={() => setOpenPrivacyModal(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.6)" },
        }}
        style={{ zIndex: 20001 }}
      >
        <Accept_Privacy onClose={() => setOpenPrivacyModal(false)} />
      </Modal>
    </>
  );
};

export default PdfViewer;
